import {
  type TableColumnFormatSwitchportIntName,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import { maybeWrapNonEmptyWithLink } from 'components/Table/cells/helpers/maybeWrapWithLink';
import {
  ARRAY_CELL_MAX_ITEMS,
  maybeWrapWithMore,
} from 'components/Table/cells/helpers/trimLargeArray';
import { pipe } from 'fp-ts/lib/function';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderSwitchportIntNameCell = <TRow,>(
  format: TableColumnFormatSwitchportIntName<TRow>,
  { row, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const content = getValueFromKeyOfType(row, format.field);
  const macCount = format.macCountField
    ? getValueFromKeyOfType(row, format.macCountField)
    : 0;
  const hasMac = macCount > 0;

  return {
    content: pipe(
      Array.isArray(content)
        ? pipe(
            content,
            (a) => a.slice(0, ARRAY_CELL_MAX_ITEMS),
            (a) => a.join(', '),
            maybeWrapWithMore(content),
          )
        : content,
      maybeWrapNonEmptyWithLink(
        row,
        severity !== null,
        format.createLinkProps,
        hasMac,
      ),
    ),
  };
};
